import PropTypes from 'prop-types';
import { Col } from 'react-bootstrap';
import QuickOperateButton from './QuickOperateButton';

const DashboardQuickLinksSidebar = ({ collapsed, onToggleCollapse }) => {
	return (
		<Col className='min-w-0 min-h-0 dashboard-screen__sidebar'>
			<QuickOperateButton collapsed={collapsed} onToggleCollapse={onToggleCollapse} />
		</Col>
	);
};

DashboardQuickLinksSidebar.propTypes = {
	collapsed: PropTypes.bool.isRequired,
	onToggleCollapse: PropTypes.func.isRequired,
};

export default DashboardQuickLinksSidebar;
